<template>
    <tr>
        <td>{{getCurrencySymbolFromString(payout.currency)}}{{(payout.amount/100).toFixed(2)}}</td>
        <td><span :class="getClassLabelStatusPayout(payout.status)" class="label">{{getStringStatusPayout(payout.status)}}</span></td>
        <td>{{getDataString(payout.created * 1000)}}</td>
        <td>{{getShortDataString(payout.arrival_date * 1000)}}</td>
        <td class="text-right"><a href="" @click.prevent.stop="$router.push({ name: 'payout_detail', params: { payout_id: payout.id }})" class="btn btn-default"><i class="las la-file-invoice-dollar"></i>{{ $t('components.payout.show_transactions') }}</a></td>
    </tr>
</template>

<script>
import {Utils} from "../../common/utils";

export default {
    name: "PayoutRow",
    props: {
        payout: {
            type: Object,
            require: true
        }
    },
    methods: {
        getDataString(date) {
            return Utils.getDateStringFromISO(date)
        },
        getShortDataString(date) {
            return Utils.getShortDateStringFromISO(date)
        },
        getStringStatusPayout(state) {
            return Utils.getStringStatusPayout(state)
        },
        getClassLabelStatusPayout(payout_state) {
            return Utils.getClassLabelStatusPayout(payout_state)
        },
        getCurrencySymbolFromString(currency) {
            return Utils.getCurrencySymbolFromString(currency)
        }
    }
};
</script>
